import { render, staticRenderFns } from "./SubjectsPregnant.vue?vue&type=template&id=124d6b40&"
import script from "./SubjectsPregnant.vue?vue&type=script&lang=js&"
export * from "./SubjectsPregnant.vue?vue&type=script&lang=js&"
import style0 from "./SubjectsPregnant.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports